module.exports = __webpack_public_path__ + "assets/img/Logitech-VC-2-Article-w540.a96989f3.webp";